<template>
  <header class="header" @mouseleave="closeList">
    <div class="header__bg"></div>
    <div class="container">
      <div class="header__wrapper">
        <router-link @mouseenter.native="closeList" class="header__logo" active-class="" exact-active-class=""
                     :to="{name: 'home'}">
          <svg width="156" height="46" viewBox="0 0 156 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M85.4022 24.0388H82.4368V4.60586H85.4022V12.2087H85.907C87.5159 12.2087 88.0522 10.4736 88.0522 9.14863V4.60586H91.0176V9.05399C91.0176 11.1045 90.2605 12.6188 88.7778 13.6283C90.3867 14.764 91.0176 16.1521 91.0176 18.2026V24.0388H88.0522V18.0764C88.0522 16.8146 87.4528 15.3003 85.9385 15.3003H85.4338V24.0388H85.4022ZM135.846 24.0388V4.60586H138.496V15.9628L141.556 4.60586H144.868V24.0388H142.187V10.5052L138.527 24.0388H135.846ZM146.95 24.0388V4.60586H149.6V15.9628L152.66 4.60586H155.973V24.0388H153.291V10.5052L149.632 24.0388H146.95ZM154.711 2.27139H148.181V0H154.711V2.27139ZM128.275 24.0388H125.309V4.60586H128.275V12.2087H128.779C130.388 12.2087 130.925 10.4736 130.925 9.14863V4.60586H133.89V9.05399C133.89 11.1045 133.133 12.6188 131.65 13.6283C133.259 14.764 133.89 16.1521 133.89 18.2026V24.0388H130.925V18.0764C130.925 16.8146 130.325 15.3003 128.811 15.3003H128.306V24.0388H128.275ZM74.487 24.0073H71.5215V4.57432H74.487H77.2946H80.3232V12.3664H77.2946V7.35045H74.487V21.2311H77.2946V16.2152H80.3232V24.0073H77.2946H74.487ZM117.359 24.0073H114.394V4.57432H117.359H120.167H123.196V12.3664H120.167V7.35045H117.359V21.2311H120.167V16.2152H123.196V24.0073H120.167H117.359ZM66.4109 7.35045H63.6348V21.2311H66.4109V7.35045ZM63.5717 24.0073H60.6063V4.57432H63.5717H66.3794H69.4079V24.0073H66.3794H63.5717ZM98.9044 7.35045H96.1282V21.2311H98.9044V7.35045ZM96.0967 24.0073H93.1312V4.57432H96.0967H98.9044H101.933V24.0073H98.9044H96.0967ZM107.012 7.35045V12.5557C108.116 12.6188 109.473 12.5557 109.473 10.5683V8.80162V7.35045H107.012ZM107.012 15.3318V21.2311H109.473C109.473 19.9693 109.473 18.7074 109.473 17.4455C109.441 15.458 108.116 15.2688 107.012 15.3318ZM112.406 7.98139V8.80162V10.379C112.406 11.9248 111.776 13.0605 110.766 13.786C111.87 14.6378 112.406 15.9943 112.406 17.6663V24.0388C110.608 24.0388 108.81 24.0388 106.98 24.0388H104.015V4.57432H106.98C108.779 4.57432 110.577 4.57432 112.406 4.57432V7.98139ZM52.2463 17.6032C53.035 13.439 54.0445 8.80162 54.5177 4.60586H58.5242V24.0388H55.9373V16.3414L56.2528 9.40101C55.8742 11.6408 54.4231 19.8746 52.5618 23.818H52.2779H51.9624C50.1011 19.8746 48.6499 11.6408 48.2714 9.40101L48.5869 16.3414V24.0388H46V4.60586H50.0065C50.4481 8.80162 51.4892 13.439 52.2463 17.6032Z" fill="#EB3333"/>
            <path d="M20.0957 35.8302C20.8213 36.7135 21.61 37.5653 22.4617 38.3539C26.4051 42.108 31.4211 44.7895 37.068 45.9252V42.5813C32.399 41.5087 28.2033 39.2057 24.8908 36.051C23.8183 35.01 22.8087 33.9058 21.9254 32.707L20.0957 35.8302Z" fill="#EB3333"/>
            <path d="M7.88646 32.3292C11.5775 28.8275 13.8488 24.0008 13.8488 18.7009V4H17.2875V18.7009C17.2875 21.2878 17.7291 24.3163 18.5178 26.6508C19.3065 24.3163 19.7481 21.2562 19.7481 18.7009V4H23.1868V18.7009C23.1868 24.0008 25.4581 28.8275 29.1491 32.3292C31.3574 34.4113 34.0389 36.0202 37.0359 36.9982V40.4368C33.0925 39.3642 29.5277 37.3452 26.72 34.6637C24.5748 32.6447 22.8713 30.2471 21.641 27.5656C20.7576 29.8686 19.7481 32.0768 18.5178 33.7173C17.2875 32.0453 16.3095 29.8686 15.3946 27.5656C14.1959 30.2156 12.4608 32.6447 10.3471 34.6637C7.50789 37.3452 3.97463 39.3642 0.03125 40.4368V36.9982C2.99667 36.0518 5.70971 34.4429 7.88646 32.3292Z" fill="#EB3333"/>
            <path d="M28.7082 18.3847C28.7082 22.265 30.3801 25.7667 33.0616 28.322C34.2289 29.4262 35.5854 30.341 37.0681 31.0351V34.5999C34.639 33.7166 32.4307 32.36 30.6325 30.6249C27.3201 27.4702 25.2695 23.1483 25.2695 18.3847V15.0723H28.7082V18.3847Z" fill="#EB3333"/>
            <path d="M8.35996 15.0723H11.7986V18.3847C11.7986 23.1483 9.74803 27.5018 6.43559 30.6249C4.63741 32.36 2.42912 33.7166 0 34.5999V31.0351C1.48271 30.341 2.83923 29.4262 4.00647 28.322C6.68797 25.7667 8.35996 22.265 8.35996 18.3847V15.0723Z" fill="#EB3333"/>
            <path d="M15.1426 32.707C14.2593 33.9058 13.2813 35.0415 12.1771 36.051C8.86471 39.2057 4.70051 41.4771 0 42.5812V45.9568C5.61537 44.8211 10.6629 42.1396 14.6063 38.3855C15.458 37.5968 16.2467 36.745 16.9723 35.8617L15.1426 32.707Z" fill="#EB3333"/>
            <path d="M47.2619 45.9578C46.4732 45.9578 46 45.4215 46 44.6959V27.8498C46 27.0926 46.5048 26.5879 47.2619 26.5879H54.423V32.1086H51.5207V29.3325H48.9023V43.1501H51.5207V39.5537H54.423V45.9578H47.2619Z" fill="#EB3333"/>
            <path d="M64.8022 26.5879V45.9578H61.8999V29.3325H58.8398V45.9578H55.9375V26.5879H64.8022Z" fill="#EB3333"/>
            <path d="M67.7365 45.9578C66.9478 45.9578 66.4746 45.4215 66.4746 44.6959V27.8498C66.4746 27.0926 66.9794 26.5879 67.7365 26.5879H73.8882C74.6768 26.5879 75.15 27.1242 75.15 27.8498V44.6643C75.15 45.4214 74.6453 45.9262 73.8882 45.9262H67.7365V45.9578ZM72.2477 29.3325H69.3454V43.1501H72.2477V29.3325Z" fill="#EB3333"/>
            <path d="M79.7246 39.5853V45.9578H76.8223V26.5879H84.1412C84.9299 26.5879 85.4031 27.1242 85.4031 27.8498V38.2918C85.4031 39.049 84.8983 39.5537 84.1412 39.5537H79.7246V39.5853ZM79.7246 36.8091H82.5007V29.3325H79.7246V36.8091Z" fill="#EB3333"/>
            <path d="M86.3809 26.5879H94.8039V29.3325H92.0278V45.9578H89.1254V29.3325H86.3809V26.5879Z" fill="#EB3333"/>
          </svg>
        </router-link>
        <nav ref="nav" class="header__nav">
          <ul>
            <li>
              <div @mouseenter="openList" ref="dropdownButton"
                   @click.self="$router.push({ name: 'allTournaments'})"
                   :class="[{active: tournamentsListVisible}, 'header-dropdown-button']">
                турниры
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 6.5L8 10.5L4 6.5" stroke="#EAEAEA" stroke-linejoin="round"/>
                </svg>
              </div>
            </li>
            <li @mouseenter="closeList" v-for="link in navItems.slice(2)" :key="link.path">
              <router-link :to="{name: link.path}" class="header__link" exact-active-class="active">{{ link.label }}</router-link>
            </li>
          </ul>
        </nav>
        <!--        <div class="header-partners">
                  <div class="partners-logo">
                    <img :src="require('@/img/partners-logo/logo1.png')" alt="#">
                  </div>
                  <div class="partners-logo">
                    <img :src="require('@/img/partners-logo/logo2.png')" alt="#">
                  </div>
                  <div class="partners-logo">
                    <img :src="require('@/img/partners-logo/logo3.png')" alt="#">
                  </div>
                  <div class="partners-logo">
                    <img :src="require('@/img/partners-logo/logo4.png')" alt="#">
                  </div>
                </div>-->
        <div class="profile-area">
          <search-input/>

          <header-profile v-if="AUTH.isAuthenticate"></header-profile>
          <div class="login-buttons" v-else>
            <button class="filled__yellow" @click.stop="showUserAuthModals">Войти</button>
          </div>
        </div>
        <media :query="{maxWidth: 1100}">
          <div class="more" @click="toggleStatusMobileNav">
            <div class="more_btn more_btn__mobile" :class="{active: this.GET_STATUS_MOBILE_NAV}">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </media>
      </div>
    </div>
    <div ref="disciplinesList" class="header-tournaments-list">
      <div class="list-wrapper" v-if="dataReady">
        <router-link :to="{name: 'sgl-events', params: {id: game.id}}" class="discipline-logo"
                     v-for="game in this.GET_TOURNAMENT_GROUPS" :key="game.id"
                     active-class=""
                     exact-active-class="">
          <img :src="GET_SPONSOR_GAMES.find(el => String(el.id) === String(game.gameInfo.id)).logo" alt="#">
        </router-link>
      </div>
    </div>

    <media :query="{maxWidth: 1100}">
      <div class="mobile_nav" :class="{active: this.GET_STATUS_MOBILE_NAV}">
        <div class="container">
          <search-input/>
          <nav>
            <ul>
              <li @click="closeMobileNav" v-for="link in navItems" :key="link.path">
                <router-link :to="{name: link.path}" class="header__link" exact-active-class="active">{{ link.label }}</router-link>
              </li>
            </ul>
          </nav>
          <media :query="{maxWidth: 580}">
            <div class="divider" v-if="AUTH.isAuthenticate"></div>
          </media>
          <media :query="{maxWidth: 580}">
            <nav v-if="AUTH.isAuthenticate">
              <ul>
                <li @click="closeMobileNav">
                  <router-link :to="{name: 'user', params: {id: USER.id}}" class="header__link"
                               exact-active-class="active">Профиль
                  </router-link>
                </li>
                <!--                <li @click="closeMobileNav">-->
                <!--                  <router-link to="/teams/create" class="header__link" exact-active-class="active">Создать команду-->
                <!--                  </router-link>-->
                <!--                </li>-->
                <li @click="closeMobileNav">
                  <div class="header__link" @click="LOGG_OUT">Выйти из аккаунта</div>
                </li>
              </ul>
            </nav>
          </media>
        </div>
      </div>
    </media>

    <login-modal
        v-if="AUTH.isAuthOpen"
    />
  </header>
</template>

<script>
import searchInput from "@/components/UIElements/InputSearch";
import HeaderProfile from "@/components/UIElements/headerProfile";
import Media from 'vue-media';
import LoginModal from "@/components/modals/login-modal";
import {mapGetters, mapActions} from 'vuex';

export default {
  name: "headerMain",
  components: {
    HeaderProfile,
    searchInput,
    Media,
    LoginModal
  },
  data() {
    return {
      tournamentsListVisible: false,
      dataReady: false,
      navItems: [
        {path: 'home', label: 'Главная'},
        {path: 'allTournaments', label: 'Турниры'},
        {path: 'news', label: 'Новости'},
        {path: 'videos', label: 'Видео'},
        {path: 'FAQ', label: 'FAQ'},
      ]
    };
  },
  computed: {
    ...mapGetters([
      'AUTH',
      'GET_STATUS_MOBILE_NAV',
      'GET_TOURNAMENT_GROUPS',
      'GET_SPONSOR_GAMES'
    ]),
  },
  methods: {
    ...mapActions([
      'SHOW_USER_AUTH_MODALS',
      'USER',
      'GET_SINGLE_USER',
      'LOGG_OUT',
      'SET_STATUS_MOBILE_NAV',
      'TOGGLE_STATUS_MOBILE_NAV',
      'SET_INACTIVE_MODAL_NOTIFICATIONS',
      'GET_DISCIPLINES',
      'SET_TOURNAMENT_GROUPS',
      'GET_SPONSOR_DISCIPLINES',
      'CLEAR_REGISTER_AFTER_AUTH_ACTION'
    ]),
    showUserAuthModals() {
      this.CLEAR_REGISTER_AFTER_AUTH_ACTION()

      // Показываем модалку с регистрацией
      this.SHOW_USER_AUTH_MODALS({isAuth: true, modal: 'password-auth'})
    },
    closeMobileNav() {
      this.SET_STATUS_MOBILE_NAV(false)
    },
    toggleStatusMobileNav() {
      this.SET_INACTIVE_MODAL_NOTIFICATIONS()
      this.TOGGLE_STATUS_MOBILE_NAV()
    },
    setLeftMargin() {
      this.$refs.disciplinesList.style.marginLeft = `${this.$refs.nav.getBoundingClientRect().left}px`
    },
    autoMargin() {
      window.addEventListener('resize', () => this.setLeftMargin())
    },
    openList() {
      this.$refs.disciplinesList.style.maxHeight = `${this.$refs.disciplinesList.scrollHeight}px`
      this.tournamentsListVisible = true
    },
    closeList() {
      this.$refs.disciplinesList.style.maxHeight = `0px`
      this.tournamentsListVisible = false
    },
    async getData() {
      //TODO надо будет убрать отсюда, потому что в App.vue мы их уже получаем. Сделать прелоадер в шапке, пока они грузятся
      await this.GET_SPONSOR_DISCIPLINES()
      await this.SET_TOURNAMENT_GROUPS()
      this.dataReady = true
    }
  },
  watch: {
    GET_STATUS_MOBILE_NAV: function () {
      // document.documentElement.style.overflow = this.GET_STATUS_MOBILE_NAV ? 'hidden' : 'auto';

      if (this.GET_STATUS_MOBILE_NAV) {
        document.body.classList.add('body_disableOverflow');
      } else {
        document.body.classList.remove('body_disableOverflow');
      }
    }
  },
  mounted() {
    this.getData()
    this.setLeftMargin()
    this.autoMargin()
    /*let showOrHideNav = new HideNavToMore('.header__nav .more', '.header__nav', '.header__nav .hidden__els', '.header__nav li', 1)
    showOrHideNav.start();*/
  }
}
</script>

<style scoped>
.filled__yellow {
  width: 200px;
  margin-right: 16px;
}
</style>
